<template>
  <v-toolbar id="main_toolbar" :style="navStyle" dark fixed app clipped-right>
    <v-toolbar-side-icon @click.stop="$emit('onTrigger')"></v-toolbar-side-icon>
    <slot name="prepend"></slot>
    <template v-if="selectedBot.theme == 'toaecoupon' && $route.name == 'template'">
      <v-menu offset-y>
        <template #activator="{ on }">
          <v-chip dark outline color="white" small v-on="on">
            <v-icon small class="mr-1">campaign</v-icon>
            <span class="hidden-xs">{{ selectCampaign ? selectCampaign.name : '-' }}</span>
            <v-icon small>arrow_drop_down</v-icon>
          </v-chip>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in campaignList"
            :key="index"
            @click="onSelectCampaign(item)"
          >
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
    <v-spacer></v-spacer>
    <v-toolbar-title>
      <div class="pt-3">
        <img
          :src="$store.state.theme.small_logo"
          class="responsive-img mt-2"
          style="max-height: 35px"
          alt
        />
      </div>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <slot name="append"></slot>
    <template v-if="showLang">
      <lang-dropdown></lang-dropdown>
    </template>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import LangDropdown from '@/components/elements/LangDropdown'
import api from '@/api'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '../../api/toa-mega-paint'
export default {
  components: {
    LangDropdown
  },
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
      env: process.env.NODE_ENV,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],

      campaignLoading: true
    }
  },
  async mounted() {
    // if (this.selectedBot == null) {
    //   this.$router.push('/' + this.currentLang + '/allbots')
    // }
    var width = window.innerWidth
    if (width <= 768) {
      this.$store.state.openSidebar = false
    }

    if (
      this.selectedBot &&
      this.selectedBot.theme == 'toaecoupon' &&
      this.$route.name == 'template'
    ) {
      this.campaignLoading = true
      await this.getEnabledCampagin()
      this.campaignLoading = false
    }
  },
  computed: {
    showLang() {
      return this.$localStorage.get('app_type') !== 'warroom'
    },
    campaignList() {
      return this.$store.state.toaEnableCampaignList
    },
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    },
    navStyle() {
      if (this.themeColor == '#FF706B')
        return 'background-image: linear-gradient(to right, #ff6868, #ffd8a4);'
      return `background-image: linear-gradient(to right, ${this.themeColor}, ${this.shadeColor(
        this.themeColor,
        74
      )});`
    },
    themeColor() {
      return this.$vuetify.theme.primary
    },
    ...mapGetters({
      // selectedBot: 'selectedBot',
      isFacebook: 'isFacebook',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      currentLang: 'currentLang'
    }),
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      }
    }
  },
  methods: {
    onSelectCampaign(item) {
      this.$store.commit('SET_TOA_CAMPAIGN', item)
    },
    async getEnabledCampagin() {
      const vm = this
      let payload = {
        pageid: vm.selectedBot.pageid,
        source: 'cms'
      }
      if (PAGE.TOA_MEGA_PAINT.includes(vm.selectedBot.pageid)) {
        try {
          let result = await toaMegapaintApi.getCampaign(payload)
          result = result.data
          let data = result.data.filter((el) => {
            return !el.is_deleted
          })
          vm.$store.commit('SET_TOA_ENABLE_CAMPAGIN', data)
          if (vm.campaignList && vm.campaignList.length > 0) {
            vm.$store.commit('SET_TOA_CAMPAIGN', vm.campaignList[0])
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        return new Promise((resolve, reject) => {
          api.TOAECOUPONgetAllCampaign(payload, async (err, result) => {
            if (result.responsecode == 200) {
              let data = result.data.filter((el) => {
                return !el.is_deleted
              })
              vm.$store.commit('SET_TOA_ENABLE_CAMPAGIN', data)
              if (vm.campaignList && vm.campaignList.length > 0) {
                vm.$store.commit('SET_TOA_CAMPAIGN', vm.campaignList[0])
              }
              resolve()
            }
            reject()
          })
        })
      }
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16)
      var G = parseInt(color.substring(3, 5), 16)
      var B = parseInt(color.substring(5, 7), 16)

      R = parseInt((R * (100 + percent)) / 100)
      G = parseInt((G * (100 + percent)) / 100)
      B = parseInt((B * (100 + percent)) / 100)

      R = R < 255 ? R : 255
      G = G < 255 ? G : 255
      B = B < 255 ? B : 255

      var RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16)
      var GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16)
      var BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16)

      return '#' + RR + GG + BB
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    selectBot: function (pageid, event) {
      this.$store.dispatch('selectBot', pageid)
    },
    openSidebar: function () {
      this.$store.dispatch('sidebar')
    },
    onError: function () {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.v-icon {
  line-height: 0 !important;
  height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/header.vue